import styled from '@emotion/styled';

export const Space = styled.div<{
	height?: number;
}>`
	height: ${(props) => props.height || '46px'};
`;
